import React from "react";
import NormalEventSettingsForm from './normal-event-settings-form';
import useMutationEeMetaSet from '../hooks/use-mutation-exbn-evnt-meta-set';
import { EXBN_EVNT_META_SET } from '../../../../graphql/mutation/exhibition-gql'

import './event-settings-form.scss';


const EventSettingsForm = ({ exbnEvnt, loadingQueryEvent }) => {

  const {
    _setMutationVariableEeMetaSet,
    loadingMutationEeMetaSet
  } = useMutationEeMetaSet(EXBN_EVNT_META_SET, exbnEvnt);



  return (
    <NormalEventSettingsForm
      exbnEvnt={ exbnEvnt }
      loadingQueryEvent={ loadingQueryEvent }
      loadingMutationEeMetaSet={ loadingMutationEeMetaSet }
      setMutationVariableEeMetaSet={ _setMutationVariableEeMetaSet }
    />
  );
};

export default EventSettingsForm;
